<template>
  <div class="main">
    <el-table
        :data="tableData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        v-loading="loading"
        style="width: 100%"
      >
        <el-table-column prop="ScenicID" label="景区ID"></el-table-column>
        <el-table-column prop="Name" label="景区名称"></el-table-column>
        <el-table-column prop="LinkMan" label="联系人"></el-table-column>
        <el-table-column prop="Phone" label="手机号"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
              {{scope.row.ExamineSmsStatus=='1'?'审核成功':scope.row.ExamineSmsStatus=='2'?'待审核':'未通过审核'}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="dete" @click="openClick(scope.row)">详情</span>
            </template>
        </el-table-column>
    </el-table>
    <el-dialog :close-on-click-modal="false"
      title="短信设置"
      :visible.sync="flow"
      :before-close="close"
      width="40%"
      center
    >
      <el-divider></el-divider>
      <div class="boxs_flow">
          <div class="contet_flow">
              <div>
                <span>短信模版内容 <span>(使用中)</span></span>
                <el-input
                  type="textarea"
                  disabled
                  v-model="item.Sms"
                  :autosize="{ minRows: 6, maxRows: 10}"
                  placeholder="请输入新短信模板内容"
                ></el-input>
              </div>
              <div>
                <span>短信模版内容<span>(待审核)</span></span>
                <el-input
                  type="textarea"
                  disabled
                  v-model="item.ExamineSms"
                  :autosize="{ minRows: 6, maxRows: 10}"
                ></el-input>
              </div>
          </div>
          <div class="contet_btns">
            <div @click="succClick">通过审核</div>
            <div @click="bohui">驳回审核</div>
          </div>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import { list_sms , Info_sms , checkSms } from '@/request/scenics.js'
import {Message} from 'element-ui'
export default {
  data(){
    return{
      data:{
        token:window.sessionStorage.getItem('Token')
      },
      loading:false,
      tableData:[],
      flow:false,
      item:''
    }
  },
  created(){
    this.getList()
  },
  methods:{
    bohui(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        ScenicID:this.item.ScenicID,
        status:3
      }
      checkSms(data).then(res=>{
        if(res.data.status=='ok'){
          Message.success('驳回审核成功')
          this.item = ''
          this.flow = false
          this.getList()
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    succClick(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        ScenicID:this.item.ScenicID,
        status:1
      }
      checkSms(data).then(res=>{
        if(res.data.status=='ok'){
          Message.success('审核成功')
          this.item = ''
          this.flow = false
          this.getList()
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    close(){
      this.flow = false
    },
    openClick(item){
      this.flow = true
      let data = {
        token:window.sessionStorage.getItem('Token'),
        ScenicID:item.ScenicID
      }
      Info_sms(data).then(res=>{
        if(res.data.rcode==200){
          this.item = res.data.result
        }
      })
    },
    getList(){
      list_sms(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result
        }
      })
    },
     // 表头设置
     tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .el-dialog__body{
  padding: 0 !important;
}
::v-deep .el-divider{
  margin: 0 !important;
}
.main{
  background: #fff;
  min-height: 100%;
  padding: 2rem;
  box-sizing: border-box;
}
.dete{
  color: #2471F6;
  cursor: pointer;
}
.boxs_flow{
  padding: 2rem;
  .contet_flow{
    display: flex;
    justify-content: space-between;
   >div{
    width: 45%;
    >span{
      color: #000000;
      font-size: 1.8rem;
      display: block;
      margin-bottom: 1rem;
      span{
        color: #246DEB;
      }
    }
   }
    /deep/.el-textarea__inner {
        width: 100%;
        height: 158px;
        padding: 20px;
        box-sizing: border-box;
        background: #f7f7fa;
        border-radius: 4px;
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: justify;
        color: #000000;
        border: none;
        resize: none;
      }
  }
}
.contet_btns{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4rem;
  div{
    width: 12rem;
    height: 4rem;
    border-radius: 0.4rem;
    background: #246DEB;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.4rem;
    margin-right: 2rem;
    cursor: pointer;
  }
}
</style>